const EDIT_POC_INFO = {
  pageTitle: 'Editar informações gerais',
  welcomeMessage:
    'Mantenha suas informações sempre atualizadas no Seu Zé, isso é extremamente importante para continuarmos a nossa parceria!',

  iconLocation: 'Ícone de pin',
  firstSubtitle: 'Informações gerais da sua loja',
  secondSubtitle: 'Contatos',
  labels: {
    document: 'CNPJ',
    tradingName: 'Nome Fantasia',
    address: 'Endereço com o número da sua loja',
    addressWithoutNumber: 'Endereço da sua loja',
    number: 'Número',
    complement: 'Complemento (opcional)',
    zipcode: 'CEP',
    pocId: 'ID',
    mainPhone: {
      outerLabel: 'Telefone do(a) responsável',
      outerSubLabel: 'Esse número precisa ter WhatsApp',
      innerLabel: 'Celular com WhatsApp',
      tooltip:
        'Nosso canal de comunicação é WhatsApp, por isso digite o seu número principal.',
    },
    establishmentPhones: {
      outerLabel: 'Outros Telefones',
      outerSubLabel:
        'Telefone(s) para clientes ou nosso time de aquisição entrarem em contato',
      innerLabel: 'Número de telefone',
    },
  },
  phoneValidation: {
    resendCodeText: 'Novo código enviado com sucesso!',
    title: 'Confirme o seu celular para continuar',
    text: 'Enviamos um código por WhatsApp para:',
    resendCodeIn: 'Reenviar o código em',
    clickToResendCode: 'Clique aqui para reenviar o código',
    confirm: 'Confirmar',
    editNumber: 'Número incorreto?',
    acessibility: {
      editNumber: 'Editar número de telefone com WhatsApp',
      inputs: 'Digite o código enviado pelo WhatsApp',
      altText:
        'Ilustração de uma mão segurando o celular, recebendo uma mensagem.',
    },
  },
  insertMainPhone: {
    title: 'Insira o seu celular para continuar',
    text: [
      'Para prosseguir com o acesso é necessário que nos informe o seu celular com',
      ' WhatsApp',
      'Dessa forma nossa equipe conseguirá entrar em contato com você quando estivermos buscando lojas na sua região.',
    ],
    confirm: 'Confirmar',
    acessibility: {
      altText:
        'Ilustração de uma mão segurando o celular, recebendo uma mensagem.',
    },
  },
  accessibility: {
    tradingName: 'Digitar o nome fantasia da loja',
    address: 'Endereço com o número da sua loja',
    addressNumber: 'Digitar o número do endereço da loja',
  },
  aditionalInfo:
    'Entre em contato pelo chat para alterar seus telefones, Razão Social e/ou o CNPJ.',
  editButton: 'Alterar Dados',
  editButtonAriaLabel: 'Botão - Alterar dados da loja',
  success: 'Dados alterados com sucesso!',
  successWithoutMainPhoneNumber: {
    title: 'Deu tudo certo!',
    text: 'Você pode editar o telefone em minha conta quando achar necessário',
  },
}

export default EDIT_POC_INFO
